import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { CheckHasAnyPermission } from "helpers/Common_functions";
import { CheckHasPermission } from "helpers/Common_functions";
import secureLocalStorage from "react-secure-storage";

const ControlledButton = (props) => {
  const {
    variant,
    onClickAction,
    label,
    icon,
    className,
    subMenuCode,
    checkSubMenuPermission,
    type,
    color,
    checkActionPermission,
    actionCode
  } = props;


  const settings = secureLocalStorage.getItem("systemSettings");
const settingsInfo = JSON.parse(settings);
const mainBackground = settingsInfo?.mainBackground;
  
  const canCreate=checkSubMenuPermission? CheckHasPermission(subMenuCode, "create"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canRead=checkSubMenuPermission? CheckHasPermission(subMenuCode, "read"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canUpdate=checkSubMenuPermission? CheckHasPermission(subMenuCode, "update"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canDelete=checkSubMenuPermission? CheckHasPermission(subMenuCode, "delete"):checkActionPermission?CheckHasAnyPermission(actionCode):true
 
  const canViewMenu =
    canCreate || canDelete || canUpdate || canDelete || canRead;

  return canViewMenu ? (
    <Button
      className={className ?? "text-red-800"}
      variant={variant ?? "contained"}
      sx={color??{
        backgroundColor: mainBackground,
        "&:hover ": { backgroundColor: mainBackground },
      }}
      color={color}
      onClick={onClickAction}
      startIcon={icon ?? null}
      type={type??"button"}
    >
      {label}
    </Button>
  ) : null;
};

export default ControlledButton;
